import React, {Component} from "react";


class InputRadio extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}};
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                <input type="radio"
                       className="coreBlockItem-input coreBlockItem-typeRadio"
                       name={name}
                       value="true"
                       checked={this.state[name] === "true"}
                       disabled={this.props.blockItem.isReadOnly}
                       onChange={this.change}/>Oui
                <input type="radio"
                       className="coreBlockItem-input coreBlockItem-typeRadio"
                       name={name}
                       value="false"
                       checked={this.state[name] === "false"}
                       disabled={this.props.blockItem.isReadOnly}
                       onChange={this.change}/>Non
            </div>
        );
    }
}

export default InputRadio;